import classNames from 'classnames'
import InStockL2Heading from '@/components/Stocks/Pages/InStockDetailPageV2/InL2Heading'
import Text from '@/stories/components/Common/NewText'

type StatItem = {
  key: string
  value: string | number
  arrow?: string | null
  classname?: string | null
}

type InvestmentStatsProps = {
  data: StatItem[]
  heading?: string
}

const InvestmentStatsTable = ({ data, heading }: InvestmentStatsProps) => {
  return (
    <div className="w-full">
      {heading && <InStockL2Heading heading={heading} />}

      <table className="w-full text-sm">
        <tbody className="grid grid-cols-1 gap-x-10 gap-y-4 md:grid-cols-2">
          {data.map(item => (
            <tr
              key={item.key}
              className="flex justify-between border-b border-gray-200 pb-2"
            >
              <td>{item.key && <Text appearance="body1">{item.key}</Text>}</td>
              <td
                className={classNames('flex items-center gap-x-1', {
                  [item.classname ?? '']: !!item.classname,
                })}
              >
                {item.arrow && (
                  <Text appearance="subtitle1">
                    {item.arrow === 'up' ? '▲' : '▼'}
                  </Text>
                )}
                {item.value && <Text appearance="subtitle1">{item.value}</Text>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default InvestmentStatsTable
